import type { FC, ReactNode } from 'react';
import { useCallback } from 'react';
import { Stack, TableCell } from '@mui/material';

import type { SortKeys, SurveyListItem } from 'src/types/survey';
import ButtonSortBy from 'src/components/common/ButtonSortBy';
import { useSurveyList } from 'src/components/survey/SurveyContext/ListContext';

import { styles } from './index.styles';

export interface TableHeaderCellProps {
  sortKey?: keyof SurveyListItem | false;
  children?: ReactNode;
}

const TableHeaderCell: FC<TableHeaderCellProps> = ({ children, sortKey }) => {
  const { sortBy, sortSurveys } = useSurveyList();
  const sort = useCallback(() => {
    if (!sortKey) return;

    const signedSortKey: SortKeys =
      sortBy === `-${sortKey}` || !sortKey ? sortKey : `-${sortKey}`;
    sortSurveys(signedSortKey);
  }, [sortBy, sortKey]);

  return (
    <TableCell sx={styles.tableHeaderCell} size="small">
      <Stack
        direction="row"
        sx={{
          height: '2rem',
        }}
      >
        <Stack
          direction="column"
          sx={styles.tableHeadline}
          onClick={sortKey ? sort : undefined}
        >
          {children}
        </Stack>
        {!!sortKey && (
          <ButtonSortBy
            sortBy={sortBy}
            onClickCallback={sort}
            sortKey={sortKey}
          />
        )}
      </Stack>
    </TableCell>
  );
};

export default TableHeaderCell;
